import { createFileRoute } from '@tanstack/react-router';
import Roles from '@/features/roles';
import { ProtectedRoute } from '@/components/auth/protected-route';
import { Permissions } from '@/constants/roles-permissions';

export const Route = createFileRoute('/_authenticated/roles')({
  component: RolesRoute,
});

function RolesRoute() {
  return (
    <ProtectedRoute requiredPermission={Permissions.RoleView}>
      <Roles />
    </ProtectedRoute>
  );
} 